import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConstants} from '../shared/app.constants';
import {AuthService} from '../auth.service';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';

@Injectable()
export class InvoiceService {

  constructor(private http: HttpClient, private appConstants: AppConstants, private auth: AuthService) {
  }

  getAllInvoices(): Observable<any> {
    const url = environment.apiBase + 'invoices';
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  updateInvoice(body): Observable<any> {
    const url = environment.apiBase + `invoices/${body.id}`;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.put(url, body, headers).map(res => res).catch(this.appConstants.errorHandler);
  }

  approveInvoice(body): Observable<any> {
    const url = environment.apiBase + 'invoices/accept';
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url, body, headers).map(res => res).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/invoices/invoice.service.ts